import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetDoctorVisitsList,
	GetDoctorVisitsListModel,
	GetDoctorVisitsListParams,
} from 'domain/usecases/private/my-hospitalization/get-doctor-visits-list';

export class RemoteGetDoctorVisitsList implements GetDoctorVisitsList {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetDoctorVisitsListModel>,
	) {}

	async get({signal, ...params}: GetDoctorVisitsListParams): Promise<GetDoctorVisitsListModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
